import { Controller } from "@hotwired/stimulus"

// converts `data-pagy` attribute of `pagy*_js` helpers
// https://ddnexus.github.io/pagy/docs/api/javascript/setup/#how-does-it-work
export default class extends Controller {
  connect () {
    Pagy.init()
  }
}
